import React, { useState } from 'react'
import { Col, Row, Modal, Input, message } from 'antd'
import FilterSelect from './Filters/FilterSelect'
import { createCategory } from '../../../services/api/apiBatchShip'
import _ from 'lodash'

const CategoryCreate = ({ isOpen, onCancel, skus = [], reload }) => {
    const [payload, setPayload] = useState({})

    const _handleChangeData = (data) => {
        setPayload(prePayload => ({
            ...prePayload,
            ...data
        }))
    }

    const handleClose = () => {
        onCancel()
        setPayload({})
    }

    const handleAddCategory = async () => {
        try {
            if (!_.get(payload, 'name')) return message.error("Cần nhập tên danh mục sản phẩm.")
            const { data } = await createCategory(payload)
            const { success, message: mess } = data

            if (!success) throw new Error(mess)
            message.success("Thêm mới danh mục thành công.")
            reload()
            handleClose()
        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <Modal
            title='Thêm mới'
            visible={isOpen}
            onCancel={handleClose}
            className='modal-add-category'
            onOk={handleAddCategory}
            okText="Thêm mới"
            cancelText="Hủy"
        >
            <Row
                gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32,
                }}
            >
                <Col className="gutter-row mb-2" span={24}>
                    <label className='mb-1 font-weight-bold'>Danh mục sản phẩm <span className='text-danger'>*</span></label>
                    <Input
                        value={payload.name}
                        placeholder='Nhập tên'
                        onChange={e => _handleChangeData({ name: e.target.value })}
                    />
                </Col>
                <Col className="gutter-row" span={24}>
                    <FilterSelect
                        field='skus'
                        value={payload['skus']}
                        onChangeFilter={_handleChangeData}
                        options={skus}
                        placeholder="Chọn SKU"
                        mode="multiple"
                        label='SKU'
                        type="create"
                    />
                </Col>
            </Row>
        </Modal>
    )
}

export default CategoryCreate